/*
 * The document's words that are drawn outside the document's own chunk (DV S-12-D14): the Activity
 * feed's rows about documents, which the shell renders on every page and the desktop banner reads,
 * long before — or without ever — a document being opened. They are merged into core's typed
 * catalogue (`core/i18n/index.ts`), so a row is checked against its keys and placeholders like any
 * other shell word, while `en.ts` beside this file stays in the document's chunk.
 *
 * Placeholders: `{name}` is a person, Claude as `doc.activity.byClaude` words it, or a visitor by
 * link as `doc.activity.byVisitor` does; `{doc}` the document's name as the row recorded it;
 * `{count}` how many things the row stands for, whose `.one` sibling is the sentence for one;
 * `{date}` a day in the account's own time zone.
 */

export const en = {
	"doc.activity.mention.title": "Mention in a document",
	"doc.activity.mention.lineComment": "{name} mentioned you in a comment on {doc}",
	"doc.activity.mention.lineText": "{name} mentioned you in {doc}",
	"doc.activity.mention.lineTextMany": "{count} mentions of you in {doc}",
	"doc.activity.byClaude": "Claude, asked by {asker}",
	"doc.activity.byVisitor": "{name} (visitor)",
	"doc.activity.reply.title": "Reply in a document",
	"doc.activity.reply.line": "{name} replied to a comment on {doc}",
	"doc.activity.reply.lineMany": "{count} replies to a comment on {doc}",
	"doc.activity.reaction.title": "Reaction",
	"doc.activity.reaction.line": "{name} reacted to your comment on {doc}",
	"doc.activity.reaction.lineMany": "{count} reactions to your comment on {doc}",
	"doc.activity.suggestion.title": "Suggestions",
	"doc.activity.suggestion.line": "{name} suggested {count} changes in {doc}",
	"doc.activity.suggestion.line.one": "{name} suggested a change in {doc}",
	"doc.activity.decided.title": "Your suggestions",
	"doc.activity.decided.accepted": "{name} accepted {count} of your suggestions in {doc}",
	"doc.activity.decided.accepted.one": "{name} accepted your suggestion in {doc}",
	"doc.activity.decided.rejected": "{name} rejected {count} of your suggestions in {doc}",
	"doc.activity.decided.rejected.one": "{name} rejected your suggestion in {doc}",
	"doc.activity.historyCut.title": "History deleted",
	"doc.activity.historyCut.line": "{name} deleted the history of {doc} before {date}",
	"doc.activity.historyCut.lineAll": "{name} deleted all earlier versions of {doc}",
	"doc.activity.historyCut.undo": "Undo until {date}",
} as const
